let host = '/';

if (process.env.NODE_ENV === 'development') {
	host = 'https://dev.torgi.teleport.mts.ru/';
}

export default {
	host,
	updateIntervalTimespan: 5 * 1000
};
